var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ServiceTicketForm',{attrs:{"value":_vm.ticket,"isEdit":true,"busy":_vm.isBusy,"saveLabel":"Update Service Ticket Details"},on:{"save":_vm.saveTicketDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }